import { render } from "./phoneComponent.vue?vue&type=template&id=b8caabb2&scoped=true"
import script from "./phoneComponent.vue?vue&type=script&lang=js"
export * from "./phoneComponent.vue?vue&type=script&lang=js"

import "./phoneComponent.vue?vue&type=style&index=0&id=b8caabb2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8caabb2"]])

export default __exports__